import React from 'react';

import styled, { css } from 'styled-components';
import settings from '../global/settings';
import VideoLightBox from './VideoLightBox';

const StVideoRow = styled.div.attrs(props => ({
    className: 'StVideoRow',
}))`
    max-width: ${settings.maxBlockWidth};
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;

     ${props =>
        props.tripleRepair &&
        css`
            max-width: 100%;
        `};
`;

const StVideoRowWrap = styled.div.attrs(props => ({
    className: 'StVideoRowWrap',
}))`
    ${props =>
        props.center &&
        css`
            justify-content: center;
        `};
    @media (min-width: ${settings.bp.medium.view}) {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -15px;
    }

        ${props =>
        props.tripleRepair &&
        css`
           @media (min-width: ${settings.bp.medium.view}) {
                margin: 0;
            }
        `};
`;

const StVideoRowItem = styled.div.attrs(props => ({
    className: 'StVideoRowItem',
}))`
    box-shadow: 2px -2px 35px 0 rgba(123, 123, 123, 0.05);
    background-color: #fff;
    margin: 0 0 24px;
    display: flex;
    text-align: left;
    min-height: 130px;
    ${props =>
        props.larger &&
        css`
    flex-direction: column;
    text-align: center;
         `};

    ${props =>
            props.columnReverse &&
            css`
                flex-direction: column-reverse;
                text-align: center;
                margin: 0px;
                 width: 100%;
            `};

    @media (min-width: ${settings.bp.medium.view}) {
        width: calc(50% - 30px);
        margin: 0 15px 30px;

        ${props =>
            props.fullWidth &&
            css`
                width: 80%;
                justify-content: center;
            `};

        ${props =>
            props.singleItem &&
            css`
                width: 100%;
                flex-direction: column;
                text-align: center;
                justify-content: center;
                margin: auto;
            `};

         ${props =>
            props.larger &&
            css`
                width: 50%;
                flex-direction: column;
                text-align: center;
                justify-content: center;
                margin: auto;

            `};


        ${props =>
            props.columnReverse &&
            css`
                flex-direction: column-reverse;
                text-align: center;
                margin: 10px;
                 width: calc(50% - 20px);
                .h3 {
                font-size: 24px;
                }
            `};
    }
`;

const StVideoRowImg = styled.div.attrs(props => ({
    className: 'StVideoRowImg',
}))`
    width: 52%;
    padding-bottom: 35%;
    height: 0;
    position: relative;

    ${props =>
        props.fullWidth &&
        css`
            width: 100%;
            padding-bottom: 60%;
        `};

    ${props =>
        props.fitWidth &&
        css`
            padding-bottom: 28%;
        `};

    ${props =>
        props.singleItem &&
        css`
            width: 100%;
            padding-bottom: 56%;
            margin: auto;
        `};

    ${props =>
            props.larger &&
            css`
                width: 100%;
                   padding-bottom: 60%;
            `};
`;

const StVideoRowDesc = styled.div`
    width: 48%;
    padding: 20px;
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 0.04em;
    font-weight: normal;

    h3 {
        margin: 0 0 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.29;
        letter-spacing: 0.05em;
        text-transform: uppercase;
    }

    p {
        margin: 0 0 16px;
    }

    *:last-child {
        margin-bottom: 0;
    }

    ${props =>
        props.singleItem &&
        css`
            width: 80%;
            margin: auto;
        `};

            ${props =>
        props.larger &&
        css`
            width: 80%;
            margin: auto;
        `};

      ${props =>
        props.columnReverse &&
        css`
           font-size: 24px;
           margin: 0px;
           width: 100%;
           text-align: center;
           padding: 12px;
             h3 {
                text-transform: unset;
                font-size: 16px;
                 @media (min-width: ${settings.bp.medium.view}) {
                 font-size: 24px;
                 }
            }
        `};
`;

function VideoRowItem(props) {
    const {
        title,
        text,
        fullWidth,
        fitWidth,
        singleItem,
        larger,
        columnReverse,
        ...restProps
    } = props;
    let showText = text || title;

    return (
        <>
            {showText && (
                <StVideoRowItem columnReverse={columnReverse} singleItem={singleItem} larger={larger}>
                    <StVideoRowImg
                        fullWidth={singleItem}
                        singleItem={singleItem}
                        fitWidth={fitWidth}
                        larger={larger}
                    >
                        <VideoLightBox {...restProps} />
                    </StVideoRowImg>
                    <StVideoRowDesc columnReverse={columnReverse} singleItem={singleItem} larger={larger}>
                        {title && <h3>{title}</h3>}
                        {text && <p>{text}</p>}
                    </StVideoRowDesc>
                </StVideoRowItem>
            )}
            {!showText && (
                <StVideoRowItem fullWidth={fullWidth} singleItem={singleItem}>
                    <StVideoRowImg fullWidth={true}>
                        <VideoLightBox {...restProps} />
                    </StVideoRowImg>
                </StVideoRowItem>
            )}
        </>
    );
}

export default function VideoRow(props) {
    const { items, center, tripleRepair, platinum,...restProps } = props;
    const singleItem = items.length === 1;
    return (
        <StVideoRow tripleRepair={tripleRepair}>
            <StVideoRowWrap tripleRepair={tripleRepair} center={center}>
                {items.map((item, index) => (
                    <VideoRowItem
                        key={item.id || index}
                        {...item}
                        {...restProps}
                        singleItem={singleItem}
                        platinum={platinum}
                    />
                ))}
            </StVideoRowWrap>
        </StVideoRow>
    );
}
